import {AfterViewInit, Component, HostListener, inject, OnInit} from '@angular/core';
import * as AOS from 'aos';

// Import all section components
import {HeaderComponent} from './components/header/header.component';
import {HeroComponent} from './components/hero/hero.component';
import {WhyUsComponent} from './components/why-us/why-us.component';
import {ASongHubComponent} from './components/a-song-hub/a-song-hub.component';
import {HowItWorksComponent} from './components/how-it-works/how-it-works.component';
import {LiveDemoComponent} from './components/live-demo/live-demo.component';
import {PricingComponent} from './components/pricing/pricing.component';
import {FooterComponent} from './components/footer/footer.component';
import {MypartHttpService} from './services/mypart-http.service';
import {ModalManagerComponent} from './shared/components/modal-manager/modal-manager.component';
// TODO: Re-enable when backend is ready for lead gen
// import {NewsletterSignupComponent} from './components/newsletter-signup/newsletter-signup.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    HeaderComponent,
    HeroComponent,
    WhyUsComponent,
    ASongHubComponent,
    HowItWorksComponent,
    LiveDemoComponent,
    PricingComponent,
    FooterComponent,
    ModalManagerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
  isScrolled = false;
  private mypartHttpService = inject(MypartHttpService);

  constructor() {
  }

  ngOnInit() {
    AOS.init({
      duration: 400,       // Animation duration in ms
      easing: 'ease-out',  // Easing for animations
      once: false,         // Whether animation should happen only once
      mirror: false,       // Whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // Defines which position of the element regarding to window should trigger the animation
      disable: false,      // Accept 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // Name of the event dispatched on the document, that AOS should initialize on
      offset: 120,         // Offset (in px) from the original trigger point
      delay: 0,            // Values from 0 to 3000, with step 50ms
    });

    // Refresh AOS after a short delay to ensure all components are loaded
    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }

  ngAfterViewInit() {
    // Refresh AOS after view initialization to ensure all components are fully rendered
    AOS.refresh();
    this.mypartHttpService.login().subscribe({
      next: value => {
      }
    });
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    // Update the isScrolled property when page is scrolled
    this.isScrolled = window.scrollY > 50;
  }

  scheduleDemo() {
    window.open('https://www.mypart.ai/contact', '_blank');
  }
}
